import type { AcademyCertificationUser, Assignment } from '~/generated_types';
import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import FetchPromise from '~/agent/fetch-promise';
import { academyRecommendedContentKeysForLearner } from './academyRecommendedContentKeyFactory';

export type AcademyExternalUserContentInfoData = {
  certificationUsers: AcademyCertificationUser['CERTIFICATIONS_PAGE'][];
  userAssignments: Assignment['ACADEMY_LEARNER_CARD_CONTENT'][];
  accessibleContentIds: string[];
};

export function useGetAcademyExternalUserContentInfo(
  { academyId }: { academyId: string },
  queryOptions: UseQueryOptions<AcademyExternalUserContentInfoData> = {},
) {
  return useQuery<AcademyExternalUserContentInfoData>({
    queryKey: academyRecommendedContentKeysForLearner.externalUserInfo(academyId),
    queryFn: () => FetchPromise.get(`academy_recommended_contents/external_user_content_info`),
    ...queryOptions,
  });
}
